import { useState, useEffect } from 'react'
import { Zap, Gamepad2 } from 'lucide-react'
import WeatherWidget from '../components/WeatherWidget'
import NewsWidget from '../components/NewsWidget'
import PolymarketMarkets from '../components/PolymarketMarkets'
import GameCenter from '../components/GameCenter'

// 轮播图数据
const banners = [
  { id: 1, title: '欢迎来到 Telegram Mini App', subtitle: '探索更多功能', color: 'from-blue-500 to-cyan-500' },
  { id: 2, title: '全新体验', subtitle: '更快、更安全', color: 'from-purple-500 to-pink-500' },
  { id: 3, title: '立即开始', subtitle: '点击了解更多', color: 'from-green-500 to-emerald-500' },
]

export default function Home() {
  const [currentBanner, setCurrentBanner] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length)
    }, 4000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className="animate-fade-in">
      {/* 轮播Banner */}
      <div className="relative h-40 mx-4 mt-4 rounded-2xl overflow-hidden">
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={`absolute inset-0 bg-gradient-to-r ${banner.color} flex flex-col justify-center px-6 transition-opacity duration-500 ${
              index === currentBanner ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <h2 className="text-xl font-bold text-white">{banner.title}</h2>
            <p className="text-white/80 text-sm mt-1">{banner.subtitle}</p>
          </div>
        ))}
        
        {/* 轮播指示器 */}
        <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentBanner(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentBanner ? 'bg-white w-4' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>

      {/* 实时天气组件 */}
      <div className="mt-6 px-4">
        <WeatherWidget />
      </div>

      {/* 全球资讯组件 */}
      <div className="mt-6 px-4">
        <NewsWidget />
      </div>

      {/* Polymarket 实时市场数据 */}
      <div className="mt-6 px-4">
        <PolymarketMarkets />
      </div>

      {/* 游戏中心 */}
      <div className="mt-6 px-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-telegram-text flex items-center">
            <Gamepad2 className="w-5 h-5 mr-2 text-purple-400" />
            休闲游戏
          </h3>
        </div>
        <GameCenter />
      </div>

      {/* 功能亮点 */}
      <div className="mt-6 px-4 pb-4">
        <div className="p-4 rounded-xl bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30">
          <div className="flex items-start space-x-3">
            <div className="p-2 bg-blue-500/20 rounded-lg">
              <Zap className="w-5 h-5 text-blue-400" />
            </div>
            <div>
              <h4 className="font-medium text-telegram-text">实时资讯</h4>
              <p className="text-sm text-telegram-secondary mt-1">
                获取全球实时天气和最新新闻资讯，随时随地掌握世界动态
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
